import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { env } from '@/config/env';
import type { DummyUserPool, PoolData, UserPool } from './userPool.types';

const poolData: PoolData = {
  UserPoolId: env.REACT_APP_USER_POOL_ID || '',
  ClientId: env.REACT_APP_CLIENT_ID || '',
};

const createDummyPool = (): DummyUserPool => ({
  getCurrentUser: () => null,
  signUp: () => Promise.reject(new Error('UserPool not configured')),
});

const initializeUserPool = (): UserPool => {
  try {
    if (poolData.UserPoolId && poolData.ClientId) {
      return new CognitoUserPool(poolData);
    } else {
      return createDummyPool();
    }
  } catch (error) {
    console.error('Failed to initialize CognitoUserPool:', error);
    return createDummyPool();
  }
};

const pool: UserPool = initializeUserPool();

export const isCognitoUserPool = (pool: UserPool): pool is CognitoUserPool => {
  return pool instanceof CognitoUserPool;
};

export const getCognitoUserPool = (): CognitoUserPool => {
  if (isCognitoUserPool(pool)) {
    return pool;
  }
  throw new Error('Cognito UserPool is not configured. Please set REACT_APP_USER_POOL_ID and REACT_APP_CLIENT_ID.');
};

export default pool;
